// Page action bar (Employees, Payroll, Attendance): one grid of equal-size
// buttons instead of a ragged row of different widths. Desktop fills the row
// with ≥200px columns; phones get two equal columns (see `.nx-action-grid` in
// styles/responsive.css), so every action stays visible and tappable.
import React from "react";
import { getTopBarButtonStyle } from "../pages/(Admin)Attendance/styles/attendanceStyles";

const PRIMARY = "#2e7cba";
const PRIMARY_HOVER = "#2563a8";

const restBg = (theme, primary) =>
  primary ? PRIMARY : theme === "dark" ? "rgba(30, 41, 59, 0.8)" : "rgba(51, 65, 85, 0.12)";
const hoverBg = (theme, primary) =>
  primary ? PRIMARY_HOVER : theme === "dark" ? "rgba(30, 41, 59, 1)" : "rgba(51, 65, 85, 0.2)";

export const ActionCountBadge = ({ count, color = "#f59e0b" }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "20px",
      height: "20px",
      padding: "0 6px",
      borderRadius: "999px",
      background: color,
      color: "#fff",
      fontSize: "11px",
      fontWeight: 700,
      flexShrink: 0,
    }}
  >
    {count}
  </span>
);

export function ActionGridButton({
  theme,
  icon: Icon,
  label,
  onClick,
  disabled = false,
  primary = false,
  active = false, // keeps the hover look (e.g. while its menu is open)
  spin = false,
  badge = 0,
  title,
  trailing = null,
  buttonRef,
  ...rest
}) {
  return (
    <button
      type="button"
      ref={buttonRef}
      className="nx-action-btn"
      onClick={onClick}
      disabled={disabled}
      title={title || (typeof label === "string" ? label : undefined)}
      style={{
        ...getTopBarButtonStyle(theme, disabled),
        ...(primary && !disabled && { background: PRIMARY, color: "#fff", border: "none" }),
        ...(active && !disabled && { background: hoverBg(theme, primary) }),
        justifyContent: "center",
        width: "100%",
        minWidth: 0,
        minHeight: "42px",
        padding: "9px 12px",
        boxSizing: "border-box",
        fontWeight: 600,
      }}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.background = hoverBg(theme, primary);
      }}
      onMouseLeave={(e) => {
        if (!disabled && !active) e.currentTarget.style.background = restBg(theme, primary);
      }}
      {...rest}
    >
      {Icon && <Icon size={16} className={spin ? "nx-spin" : undefined} style={{ flexShrink: 0 }} />}
      <span className="nx-action-label">{label}</span>
      {badge > 0 && <ActionCountBadge count={badge} />}
      {trailing}
    </button>
  );
}

export default function ActionButtonGrid({ theme, children, divider = true, style }) {
  return (
    <div
      className="nx-action-grid"
      style={{
        ...(divider && {
          paddingTop: "16px",
          borderTop: theme === "dark" ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.1)",
        }),
        ...style,
      }}
    >
      {children}
    </div>
  );
}
